import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'trusts-manager',
  templateUrl: 'trusts-manager.component.html'
})
export class TrustsManagerComponent {
  public active = 0;

  constructor(private router: Router) {
    router.events.subscribe((event: NavigationEnd) => this.handleRouterChanges(event));
  }

  private handleRouterChanges(event: NavigationEnd): void {
    if (!(event instanceof NavigationEnd) || !event.url || event.url.indexOf('trusts-manager/') === -1) {
      return;
    }

    if (event.url.indexOf('trusts-manager/trusts') !== -1) {
      this.active = 0;
    } else if (event.url.indexOf('trusts-manager/trust-holders') !== -1) {
      this.active = 1;
    }
  }
}
